import { defineStore } from 'pinia';

export const usePaymentSettingsStore = defineStore('paymentSettings', {
  state() {
    return {
      settings: {},
      feesData: {
        totalFeeUsed: 0,
        totalFeeNew: 0,
      },
      shiftDigitalDone: false,
      paymentsFeesData: '',
      expressPaymentsFeesData: '',
      isVehicleDetailsPage: false,
      completePaymentsData: '',
      showTransactPopup: false,
      interestedComponentType: '',
      showTransactPopupIframe: false,
      settingssuccess: false,
      vdpContactFromTransact: false,
      vdpContactFromPaymentPanel: false,
      showVdpContactUS: false,
      showTextMeQuote: false,
      showRequestVideo: false,
      showDownPaymentMessage: false,
      vdpContactUsZindex: false,
      unlockEPriceCookie: true,
      unlockEPriceCookieVin: true,
      unlockCashPriceDiscount: true,
      transactUnlockFormModal: true,
      showOverLayPaymentsData: '',
      cashTradeValue: 0,
      cashPriceDiscountValue: 0,
      selectedPaymentOption: constants.LEASE,
      miles: [],
      leasedata: '',
      totalLeaseData: '',
      leaseTerms: [],
      financeTerms: [],
      gotpayments: false,
      financedata: '',
      showLoading: false,
      showLeaseTab: false,
      showFinanceTab: false,
      pageStateKey: '',
      paymentConfiguration: PAYMENT_CONFIGURATION_DETAILS,
      paymentConfiguration: {
        selectedPayment: '',
        mileage: '',
        downPayment: '',
        tradeValue: '',
        term: '',
      },
      previousSelectedValues: {
        lease: {
          selectedPayment: '',
          mileage: '',
          downPayment: '',
          tradeValue: '',
          term: '',
        },
        finance: {
          selectedPayment: '',
          mileage: '',
          downPayment: '',
          tradeValue: '',
          term: '',
        },
      },
      interestedActiveComponent: '',
      ctaActiveComponent: '',
      lockInPaymentType: '',
      ctaActiveComponentProps: {},
      formHeading: '',
      formButtonLabel: '',
      formActionName: '',
      formButtonColor: '',
      formButtonFontColor: '',
      isTransact: false,
      smartPathUnlockStatus: '',
      fordDirectQualifiedIncentives: {},
      conditionalRebateIncentives: {},
      rebateLabel: '',
      discountLabel: '',
      finalPriceLabel: '',
      smartpathDealerDisclaimer: '',
      smartpathDDOADisclaimer: '',
      softPullVehiclePrice: 0,
      getSoftPullSettings: {},
      feesResults: '',
      aisRebates: {},
      standardFinanceVehicleData: {},
      paymentCalculatorInteractionCount: 0,
      sendToPhoneVdv: false,
      vdpPrintPriceDetails: '',
      vdpPrintCfp: '',
      alternatePayments: {
        rebates: {
          label: '',
          value: '',
        },
        fee: {
          label: '',
          value: '',
        },
        tax: {
          label: '',
          value: '',
        },
      },
      unlockCtaDiscountData: {},
    };
  },
  actions: {},
});
